import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

class YesAndNo extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    const { badge = '', badgeWhy = '', uniform = '', uniformWhy = '', yardSign = '',
            yardSignWhy = '', oilShield = '', oilShieldWhy = '', tarp = '', tarpWhy = '',
            properTools = '', properToolsWhy = '' } = this.props;
    this.state = {
      badge,
      badgeWhy,
      uniform,
      uniformWhy,
      yardSign,
      yardSignWhy,
      oilShield,
      oilShieldWhy,
      tarp,
      tarpWhy,
      properTools,
      properToolsWhy,
      errors: {},
    };
  }

  static VALIDATIONS = {
    badge: true,
    uniform: true,
    yardSign: true,
    oilShield: true,
    tarp: true,
    properTools: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    const { badge, badgeWhy, uniform, uniformWhy, yardSign, yardSignWhy, oilShield,
            oilShieldWhy, tarp, tarpWhy, properTools, properToolsWhy } = this.state;
    this.props.updateFormData({
      badge,
      badgeWhy,
      uniform,
      uniformWhy,
      yardSign,
      yardSignWhy,
      oilShield,
      oilShieldWhy,
      tarp,
      tarpWhy,
      properTools,
      properToolsWhy,
      tab: 3,
    });
  }

  handlePrevious = () => this.props.updateFormData({
    badge: this.state.badge,
    badgeWhy: this.state.badgeWhy,
    uniform: this.state.uniform,
    uniformWhy: this.state.uniformWhy,
    yardSign: this.state.yardSign,
    yardSignWhy: this.state.yardSignWhy,
    oilShield: this.state.oilShield,
    oilShieldWhy: this.state.oilShieldWhy,
    tarp: this.state.tarp,
    tarpWhy: this.state.tarpWhy,
    properTools: this.state.properTools,
    properToolsWhy: this.state.properToolsWhy,
    tab: 1,
  });

  handleBadge = value => this.setState({ badge: value });

  handleBadgeWhy = e => this.setState({ badgeWhy: e.target.value });

  handleUniform = value => this.setState({ uniform: value });

  handleUniformWhy = e => this.setState({ uniformWhy: e.target.value });

  handleYardSign = value => this.setState({ yardSign: value });

  handleYardSignWhy = e => this.setState({ yardSignWhy: e.target.value });

  handleOilShield = value => this.setState({ oilShield: value });

  handleOilShieldWhy = e => this.setState({ oilShieldWhy: e.target.value });

  handleTarp = value => this.setState({ tarp: value });

  handleTarpWhy = e => this.setState({ tarpWhy: e.target.value });

  handleProperTools = value => this.setState({ properTools: value });

  handleProperToolsWhy = e => this.setState({ properToolsWhy: e.target.value });

  render = () => {
    const { badge, badgeWhy, uniform, uniformWhy, yardSign, yardSignWhy, oilShield,
            oilShieldWhy, tarp, tarpWhy, properTools, properToolsWhy, errors } = this.state;
    const buttons = [{ label: 'YES', value: 'YES' }, { label: 'NO', value: 'NO' }];
    return (<div>
      <h6 className={S.signatureTitle}>Yes Or No</h6>
      <RadioButtons
        label="Badge*"
        required
        onChange={this.handleBadge}
        selectedValue={badge}
        radioButtons={buttons}
      />
      {badge === 'NO' && <SimpleInput
        label="Why No Badge?*"
        required
        text={badgeWhy}
        errors={errors.badgeWhy}
        onChange={this.handleBadgeWhy}
      />}
      <RadioButtons
        label="Uniform*"
        required
        onChange={this.handleUniform}
        selectedValue={uniform}
        radioButtons={buttons}
      />
      {uniform === 'NO' && <SimpleInput
        label="Why No Uniform?*"
        required
        text={uniformWhy}
        errors={errors.uniformWhy}
        onChange={this.handleUniformWhy}
      />}
      <RadioButtons
        label="Yard Sign*"
        required
        onChange={this.handleYardSign}
        selectedValue={yardSign}
        radioButtons={buttons}
      />
      {yardSign === 'NO' && <SimpleInput
        label="Why No Yard Sign?*"
        required
        text={yardSignWhy}
        errors={errors.yardSignWhy}
        onChange={this.handleYardSignWhy}
      />}
      <RadioButtons
        label="Oil Shield*"
        required
        onChange={this.handleOilShield}
        selectedValue={oilShield}
        radioButtons={buttons}
      />
      {oilShield === 'NO' && <SimpleInput
        label="Why No Oil Shield?*"
        required
        text={oilShieldWhy}
        errors={errors.oilShieldWhy}
        onChange={this.handleOilShieldWhy}
      />}
      <RadioButtons
        label="Tarp*"
        required
        onChange={this.handleTarp}
        selectedValue={tarp}
        radioButtons={buttons}
      />
      {tarp === 'NO' && <SimpleInput
        label="Why No Tarp?*"
        required
        text={tarpWhy}
        errors={errors.tarpWhy}
        onChange={this.handleTarpWhy}
      />}
      <RadioButtons
        label="Proper Tools*"
        required
        onChange={this.handleProperTools}
        selectedValue={properTools}
        radioButtons={buttons}
      />
      {properTools === 'NO' && <SimpleInput
        label="Why No Proper Tools?*"
        required
        text={properToolsWhy}
        errors={errors.properToolsWhy}
        onChange={this.handleProperToolsWhy}
      />}
      <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
    </div>);
  }
}

YesAndNo.propTypes = {
  phase: PhaseType.isRequired,
  badge: PropTypes.string,
  badgeWhy: PropTypes.string,
  uniform: PropTypes.string,
  uniformWhy: PropTypes.string,
  yardSign: PropTypes.string,
  yardSignWhy: PropTypes.string,
  oilShield: PropTypes.string,
  oilShieldWhy: PropTypes.string,
  tarp: PropTypes.string,
  tarpWhy: PropTypes.string,
  properTools: PropTypes.string,
  properToolsWhy: PropTypes.string,
  errors: PropTypes.shape({
    badge: PropTypes.arrayOf(PropTypes.string),
    badgeWhy: PropTypes.arrayOf(PropTypes.string),
    uniform: PropTypes.arrayOf(PropTypes.string),
    uniformWhy: PropTypes.arrayOf(PropTypes.string),
    yardSign: PropTypes.arrayOf(PropTypes.string),
    yardSignWhy: PropTypes.arrayOf(PropTypes.string),
    oilShield: PropTypes.arrayOf(PropTypes.string),
    oilShieldWhy: PropTypes.arrayOf(PropTypes.string),
    tarp: PropTypes.arrayOf(PropTypes.string),
    tarpWhy: PropTypes.arrayOf(PropTypes.string),
    properTools: PropTypes.arrayOf(PropTypes.string),
    properToolsWhy: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(YesAndNo);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/yesAndNo.jsx